export class VodQueryParams {
  constructor(
    public page?: number,
    public pageable?: boolean,
    public itemCount?: number,
    public contentName?: string,
    public status: string[] = [],
    public id?: number,
    public guid?: string,
    public year?: string[],
    public vodType: string[] = ['Vod'],
    public videoOperationProcessName?: string[],
    public videoOperationProcessStatus?: string[],
    public startTime?: number[],
    public endTime?: number[],
    public vfoStartTime?: number[],
    public vfoEndTime?: number[],
    public planStartTime?: number[],
    public planEndTime?: number[],
    public platform?: string[],
    public serviceType?: string[],
    public licenseServiceType?: string[],
    public planServiceType?: string[],
    public planStatus?: string[],
    public categoryId?: number[],
    public title?: string,
    public duration?: number,
    public minDuration?: number,
    public maxDuration?: number,
    public contentType?: string,
    public actors?: number[],
    public directors?: number[],
    public videoFormat?: string[],
    public aspectRatio?: string[],
    public imdbRating?: number,
    public type?: string[],
    public provider?: string[],
    public castName?: string,
    public quickFilter?: string,
    public pageSize?: number,
    public licenseTba?: boolean,
    public videoOperationFailed?: boolean,
    public migrated?: boolean,
    public labelId: number[] = [],
    public contentGroupIds: number[] = [],
    public blackPeriods?: boolean,
    public mwInternalCode?: string,
    public videoOperationNotAssigned?: boolean,
    public endYear?: string,
    public startYear?: string,
    public comingSoon?: boolean,
    public isValidMetadata?: boolean,
    public isValidPoster?: boolean, // bu kontrol edilecek banner oluşturulurken
    public genreIds: Array<number> = new Array<number>(),
    public trailerWaiting?: boolean,
    public trailerOperationNotAssigned?: boolean,
    public country?: string[],
    public originalLanguage?: string[],
    public contentGroupName?: string,
    public contentGroupId?: number,
    public publishTime?: number[],
    public unpublishedTime?: number[],
    public trailerPriority?: string[],
    public trailerPromo?: string[],
    public broadCastTime?: number[],
    public withoutPoster?: boolean,
    public withoutMetadata?: boolean,
    public withoutPlan?: boolean,
    public vfoContentReport?: boolean,
    public trailerOperationProcessNames?: string[],
    public castId?: number[],
    public metadataSummary?: string,
    public sortParam?: string[],
    public trailerNotCompleted?: boolean,
    public trailerCompleted?: boolean,
    public trailerAssignee?: string,
    public trailerCompletionTime?: number[],
    public isHaveTrailer?: boolean,
    public contentStatus?: string,
    public contentIssueTypeName?: string,
    public action?: string,
    public actionTimeStart?: number,
    public actionTimeEnd?: number,
    public userId?: number,
    public issueTypeId?: number,
    public name?: string,
    public userName?: string,
    public validationChangeType?: string,
    public finishTimeStart?: number,
    public finishTimeEnd?: number,
    public processName?: string,
    public contentGuid?: string,
    public contentTypes?: string[],
    public completionTime?: number,
    public isActive?: boolean,
    public channelName?: string,
    public bannerType?: string,
    public jobStartDate?: number,
    public jobStatus?: string,
    public jobEndDate?: number,
    public trimStatus?: string,
    public sectionInfo?: boolean,
    public seriesName?: string,
    public seasonNo?: number,
    public episodeNo?: number,
    public nameSearch?: string,
  ) {}
}
// page?: number,
// itemCount?: number,
// contentName?: string,
// status?: string[],
// guid?: string,
// year?: string,
// vodType?: string[],
// videoOperationProcessName?: string[],
// startTime?: number,
// endTime?: number,
// platform?: string[],status
// serviceType?: string[],
// title?: string,
// duration?: number,
// director?: string[],
// actor?: string[],
// videoFormat?: string[],
// aspectRatio?: string[],
// imdbRating?: number,
// type?: string,
// contentType?: string,
// provider?: string[],
